import { z } from 'zod';
import type { UpdateConfigFarmaPayload } from './service/IPAConfigFarma';
import type { ConfigFarmaResponse } from './types/ConfigFarmaResponse';

export const pmcSourceSchema = z.enum(['MINISTRY_OF_HEALTH', 'CLIENT_ERP']);

export type PmcSource = z.infer<typeof pmcSourceSchema>;

export const DEFAULT_PMC_SOURCE: PmcSource = 'MINISTRY_OF_HEALTH';

export const setupFarmaSchema = z.object({
  usePMCForIPAPricing: z.boolean(),
  pmcConfig: pmcSourceSchema,
});

export type SetupFarmaFormValues = z.infer<typeof setupFarmaSchema>;

export const DEFAULT_SETUP_FARMA_VALUES: SetupFarmaFormValues = {
  usePMCForIPAPricing: false,
  pmcConfig: DEFAULT_PMC_SOURCE,
};

export const toSetupFarmaFormValues = (config: ConfigFarmaResponse): SetupFarmaFormValues => ({
  usePMCForIPAPricing: config.usePMCForIPAPricing,
  pmcConfig: config.pmcConfig ?? DEFAULT_PMC_SOURCE,
});

export const toUpdateConfigFarmaPayload = (values: SetupFarmaFormValues): UpdateConfigFarmaPayload => ({
  usePMCForIPAPricing: values.usePMCForIPAPricing,
  pmcConfig: values.usePMCForIPAPricing ? values.pmcConfig : null,
});
